module.exports = __webpack_public_path__ + "static/media/uoa-25.beacb896.jpg";